import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DividerProps } from "./types";

function Divider({
  color = "border-border",
  thickness = "border-t",
  margin = "my-4",
  orientation = "horizontal",
  className,
  ...props
}: DividerProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <hr
      className={cn(
        "w-full",
        orientation === "vertical" && "h-auto w-auto border-l",
        color,
        thickness,
        margin,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default Divider;
